import script from "./ToDoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToDoView.vue?vue&type=script&lang=ts&setup=true"

import "./ToDoView.vue?vue&type=style&index=0&id=e1ac2110&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1ac2110"]])

export default __exports__